import { render, staticRenderFns } from "./POIDestinationState.vue?vue&type=template&id=42b10bb4"
import script from "./POIDestinationState.js?vue&type=script&lang=js&external"
export * from "./POIDestinationState.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports